// Triggers a browser download for a Blob with the given filename. Replaces the
// previously used `file-saver` package — we only ever called `saveAs(blob, name)`,
// and modern browsers (the only ones we support) handle `<a download>` natively.
export function saveAs(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}
